import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EnvelopeOpen } from "@phosphor-icons/react";
import { api } from "../api";
import { useMe } from "../auth";

/** Soft (non-blocking) reminder to confirm email. Hidden once verified. */
export function EmailVerifyBanner() {
  const { t } = useTranslation("auth");
  const { data: me } = useMe();
  const [state, setState] = useState<"idle" | "sending" | "sent" | "error">("idle");

  // Only email-based accounts that aren't verified yet. TG/Google accounts
  // have email_verified=true from the DTO.
  if (!me || !me.email || me.email_verified !== false) return null;

  const resend = async () => {
    setState("sending");
    try {
      await api.post("/athlete/auth/resend-verification");
      setState("sent");
    } catch {
      setState("error");
    }
  };

  return (
    <div className="mx-3 mt-3 rounded-tile border border-amber-500/30 bg-amber-500/10 px-4 py-3 flex items-start gap-3">
      <EnvelopeOpen className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-fg-primary">{t("verify_banner.text")}</p>
        {state === "sent" ? (
          <p className="text-xs text-amber-300 mt-1">{t("verify_banner.sent")}</p>
        ) : state === "error" ? (
          <p className="text-xs text-rose-400 mt-1">{t("verify_banner.error")}</p>
        ) : (
          <button
            type="button"
            onClick={resend}
            disabled={state === "sending"}
            className="text-xs font-medium text-amber-300 hover:text-amber-200 mt-1 disabled:opacity-60"
          >
            {state === "sending" ? t("verify_banner.sending") : t("verify_banner.resend")}
          </button>
        )}
      </div>
    </div>
  );
}
